<template>
  <div class="hora">
    <div
      class="container pt-3 pb-3"
      style="direction: ltr">
      <div class="row justify-content-md-center">
        <div class="col-12 col-md-10 mr-auto mx-auto mb-3">
          <div
            v-if="loadData['user']"
            class="now-analysis p-3"
          >
            شما در حال مشاهده چارت همین لحظه در ساعت
            <b>
              {{
                `${loadData["user"]["hour"]}:${loadData["user"]["min"]}:${loadData["user"]["sec"]}`
              }}
            </b>
            ، تاریخ
            <b>
              {{ getNowDate() }}
            </b>
            و منطقه‌زمانی
            <b>
              {{ `${loadData["user"]["timezone"]}` }}
            </b>
            هستید.
            <br>
            اسندانت این چارت در برج
            <b>
              <a
                :href="getSignLink(loadData)"
                target="_blank">{{
                  formatLagnaText(loadData["lagna"]["Lg"]["rashi"])[0]
                }}</a>
            </b>
            قرار دارد.
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div
          ref="chart_box"
          class="col-12 col-md-10 col-xl-5 p-0 m-0 m-md-3 order-1 order-md-2"
        >
          <keep-alive>
            <Chart
              v-if="loadData['bhava'] && loadData['graha']"
              :varga_number="'D1'"
              :varga_name="'Rasi'"
              :bhavas="loadData['bhava']"
              :grahas="loadData['graha']"
              :show_degree="true"
              :is_main_chart="true"
              :box_width="home_chart_box"
              class="mr-auto mx-auto"
              style="box-shadow: 0 2px 8px 0 rgba(0,0,0,0.08); border: 1px solid #ccc"
            />
          </keep-alive>
        </div>
        <div
          ref="pt_box"
          class="col-12 col-md-10 col-xl-5 p-0 m-0 m-md-3 mt-t m-md-0 order-2 order-md-1"
        >
          <PlanetryTableFree
            :grahas="loadData['graha']"
            :box_width="home_pt_box"
            :lagna="loadData['lagna']"
            :is-home-view="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../service/api'
import Chart from '../components/Chart.vue'
import ChartInfoFree from '../components/ChartInfoFree.vue'
import PlanetryTableFree from '../components/PlanetryTableFree.vue'
import DashaTable from '../components/DashaTable.vue'
import HelperLib from '../components/helper'
import HoraLogo from '../components/HoraLogo.vue'
import moment from 'jalali-moment'

export default {
  name: 'HomeView',
  components: {
    Chart,
    ChartInfoFree,
    PlanetryTableFree,
    DashaTable,
    HelperLib,
    HoraLogo
  },
  data () {
    return {
      loadData: [],
      home_chart_box: 525,
      home_pt_box: 355
      // chart_wrapper_width: '550px'
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      ApiService.getTehranNow().then((response) => (this.loadData = response['data']))
    })
    if (HelperLib.isMobile()) {
      this.home_chart_box = (window.screen.width * 92) / 100
      this.home_pt_box = (this.$refs.pt_box.clientWidth * 92) / 100
      // this.chart_wrapper_width = '340px'
    }
  },
  methods: {
    getNowDate () {
      const now = moment().locale('fa').utcOffset('+03:30')
      return now.format('D') + ' ' + now.format('MMMM') + ' ' + now.format('YYYY')
    },
    formatLocation (user) {
      let lonDir = user['longitude'] < 0 ? 'W' : 'E'
      let latDir = user['latitude'] < 0 ? 'S' : 'N'
      let out =
        user['latitude_dms']['deg'] +
        ' ' +
        latDir +
        ' ' +
        user['latitude_dms']['min'] +
        ' - '
      out +=
        user['longitude_dms']['deg'] + ' ' + lonDir + ' ' + user['longitude_dms']['min']
      return out
    },
    getNowAnalysis (user) {
      let time = user['hour'] + ':' + user['min'] + ':' + user['sec']
      // let date = user["j_year"] + "-" + user["j_month"] + "-" + user["j_day"];
      let out = `
      شما در حال مشاهده چارت در ساعت ${time} و تاریخ  هستید.
      `
      return out
    },
    formatLagnaText (rashi) {
      return HelperLib.rashiToPersianText(rashi)
    },
    getSignLink (data) {
      var lagna = HelperLib.rashiToPersianText(data['lagna']['Lg']['rashi'])
      return `${lagna[1]}`
    }
  }
}
</script>

<style scoped>
.now-analysis {
  direction: rtl;
  text-align: right;
  font-size: 16px;
  color: black;
  text-align: center;
  text-shadow: #fff 1px 1px 1px;
  background: rgb(255, 255, 255);
  border-radius: 5px;
  color: #000;
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.08);
}
</style>
